<div *ngIf="data">
  <mat-dialog-content>
    <h3>Are you sure you meant to enter {{data | number}} miles</h3>
  </mat-dialog-content>
  <mat-dialog-actions>
    <button mat-raised-button type="button" color="warn" [mat-dialog-close]="true">Yes</button>
    <button mat-raised-button type="button" color="primary" [mat-dialog-close]="false">No</button>
  </mat-dialog-actions>
</div>